const options = [
  { value: 'paymentDate', label: 'Data de pagamento' },
  { value: 'createdAt', label: 'Data de criação' },
  { value: 'made_effective', label: 'Data de efetivação' },
]

export { options }
